import PropTypes from "prop-types";

const ADMIN_FORM = PropTypes.shape({
  adminPayment: PropTypes.string,
  adminCustomAmount: PropTypes.string,
  adminBillingGroupId: PropTypes.string,
  adminRenewalOption: PropTypes.string,
  restrictCancellation: PropTypes.bool
});

const billingGroupOptionShape = PropTypes.shape({
  partner: PropTypes.shape({
    name: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({ label: PropTypes.string, value: PropTypes.number })
    )
  }),
  other: PropTypes.shape({
    name: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({ label: PropTypes.string, value: PropTypes.number })
    )
  })
});

const ADMIN_PAYMENT_METHOD = PropTypes.shape({
  isEnabled: PropTypes.bool,
  fundingSourceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  billingGroupOptions: billingGroupOptionShape,
  linkedBillingGroupOptions: billingGroupOptionShape
});

export { ADMIN_PAYMENT_METHOD, ADMIN_FORM };
